import styled from "styled-components";
import React from "react";

const RAVideo = React.forwardRef(({ path, width = "100%", height }, ref) => (
	<WrapperVideo>
		<video
			ref={ref}
			src={path}
			autoPlay
			muted
			playsInline
			style={{
				width: width,
				height: height,
				objectFit: "cover",
			}}
		/>
	</WrapperVideo>
));

RAVideo.displayName = "RAVideo";

export { RAVideo };

const WrapperVideo = styled.div`
	video::-webkit-media-controls {
		display: none;
	}
	video::-webkit-media-controls-panel {
		display: none;
	}
`;
